import { BaseTag } from 'mixs/base/base_mixin';
import { Scopes } from 'apps/scopes';
import moment  from 'moment';
import {
  DELIVERY_CLICK_EACH_SAVE
} from 'apps/events';

class TodaysDeliveriesTask extends BaseTag {
  protected topScope: string = 'tasks'
  protected dispatchAction(){ return App.actions.planner.tasks; }
  o: any;
  t: any;
  l: any;
  p: any;
  do1: any;
  do2: any;
  d: any;
  init(){
    super.init();
    this.watch();
    this.o = Scopes.getOrderData(this.opts.order_id)
    this.t = Scopes.getTaskableData(this.opts.taskable_id, this.opts.taskable_type);
    this.d = this.getDeliveryPhase()
    let delivery_option_ids = this.t.delivery_option_ids
    if(delivery_option_ids[0]) this.do1 = Scopes.getDeliveryOptionData(delivery_option_ids[0])
    if(delivery_option_ids[1]) this.do2 = Scopes.getDeliveryOptionData(delivery_option_ids[1])
    if(this.t.location_id){
      this.l = Scopes.getLocationData(this.t.location_id);
    }
    if(this.t.locations_person_id){
      this.p = Scopes.getLocationsPersonData(this.t.locations_person_id)
    }
    // this.listenMount([this.onMountTodaysDeliveriesTask]);
  }
  // onMountTodaysDeliveriesTask(){
    // let elements = this.querySelectorAll('[data-toggle="tooltip"]');
  // }
  recordExist(){
    let recordData = Scopes.getDeliveryRecordData(this.opts.taskable_id)
    if(recordData != undefined && recordData.id != undefined){ return true;}
    return false;
  }
  inputNameBase(){
    let recordData = Scopes.getDeliveryRecordData(this.opts.taskable_id)
    if(recordData){ return "records[" + recordData.id + "]"}
    return "new_records["
  }
  record_number(){
    let recordData = Scopes.getDeliveryRecordData(this.opts.taskable_id)
    if(recordData){ return recordData.number }
    return 1
  }
  record_memo(){
    let recordData = Scopes.getDeliveryRecordData(this.opts.taskable_id)
    if(recordData){ return recordData.memo }
    return '';
  }
  record_memo1(){
    let recordData = Scopes.getDeliveryRecordData(this.opts.taskable_id)
    if(recordData){ return recordData.memo1 }
    return '';
  }
  record_value(){
    let recordData = Scopes.getDeliveryRecordData(this.opts.taskable_id)
    if(recordData){ return recordData.value }
    return '';
  }
  record_todays_value(){
    let recordData = Scopes.getDeliveryRecordSumData(this.opts.taskable_id)
    if(recordData){ return recordData.memo_theday }
    return ' '
  }
  isDifferentTodaysValue(){
    return this.record_value() != this.record_todays_value()
  }
  memo(){
    let theDate = this.parent.opts.start;
    let theDateMoment = moment(theDate);
    let taskScheduleIds = this.opts.schedules
    let index = 0;
    for(let i=0;i<taskScheduleIds.length;i++){
      let scheduleId = taskScheduleIds[i];
      let scheduleData = Scopes.getScheduleData(scheduleId);
      let startMoment = moment(scheduleData.start_time)
      let endMoment = moment(scheduleData.end_time)
      if(theDateMoment.isBefore(startMoment) || theDateMoment.isAfter(endMoment)){
        index += endMoment.diff(startMoment, 'days') + 1;
      }else{
        index += theDateMoment.diff(startMoment, 'days')
        break;
      }
    }
    let composite_id = this.opts.id + '_' + index;
    let memoData = Scopes.getTasksMemoData(composite_id);
    if(memoData){ return memoData.value; }
    // let recordData = Scopes.getDeliveryRecordData(this.opts.taskable_id)
    // if(recordData){ return recordData.number }
    return ' '
  }
  total(){
    return this.o.required_num;
  }
  getDeliveryPhase(){
    let phase;
    let phaseData = Scopes.getPhaseDataByIdentity('delivery')
    if(this.o.phases == null){ return '';}
    for(let i=0; i<this.o.phases.length; i++){
      let d = this.o.phases[i];
      if(d.id == phaseData.id){
        phase = d;
        break;
      }
    }
    if(phase == null){ return ''}
    return phase
  }
  orderDescription(){
    return this.d.description.value;
  }
  taskDescription(){
    return this.opts.memo;
  }
  clipboard(e){
    e.preventDefault()
    let text = e.currentTarget.getAttribute('data-text');
    this.copyToClipboard(text);
    let options = {
      type: 'success',
      text: this.locale().clipboard_prefix + text + this.locale().clipboard_suffix
    }
    App.notify.createNotify(options)
    return false;
  }
  copyToClipboard(str){
    const el = document.createElement('textarea');  // Create a <textarea> element
    el.value = str;                                 // Set its value to the string that you want copied
    el.setAttribute('readonly', '');                // Make it readonly to be tamper-proof
    el.style.position = 'absolute';
    el.style.left = '-9999px';                      // Move outside the screen to make it invisible
    document.body.appendChild(el);                  // Append the <textarea> element to the HTML document
    const selected =
      document.getSelection().rangeCount > 0        // Check if there is any content selected previously
        ? document.getSelection().getRangeAt(0)     // Store selection if found
        : false;                                    // Mark as false to know no selection existed before
    el.select();                                    // Select the <textarea> content
    document.execCommand('copy');                   // Copy - only works as a result of a user action (e.g. click events)
    document.body.removeChild(el);                  // Remove the <textarea> element
    if (selected) {                                 // If a selection existed before copying
      document.getSelection().removeAllRanges();    // Unselect everything on the HTML document
      document.getSelection().addRange(selected);   // Restore the original selection
    }
  }
  onClickEachSave(e){
    let taskable_id = e.currentTarget.dataset.id
    var customEvent = new CustomEvent(DELIVERY_CLICK_EACH_SAVE, { detail: taskable_id });
    document.dispatchEvent(customEvent);
  }
}

riot.mixin('todays.deliveries.task', TodaysDeliveriesTask as riot.TagMixin)
